import {put,takeLatest,call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    SAVE_CARD,
    SAVE_CARD_SUCCESS,
    SAVE_CARD_ERROR,
}
    from "../../actions/payment"

function* saveCardSaga(action) {
    try {
        const data=yield call(paymentService.SaveCard,action.payload)

        if(data.outbound.rawData.Sonuc===1) {
            if(action.payload.payload.uid) {
                const cardsdata=yield call(paymentService.ListCards,{payload: {uid: action.payload.payload.uid},corsSecure: true}) 
                yield put({
                    type: SAVE_CARD_SUCCESS,
                    payload: cardsdata
                })
            }
        }
        else {
            yield put({
                type: SAVE_CARD_ERROR,error: data.outbound.rawData.Sonuc_Str
            })
        }


    } catch(error) {
        yield put({
            type: SAVE_CARD_ERROR,error: error.data
        })
    }
}


export function* saveCardSagaWatcher() {
    yield takeLatest(SAVE_CARD,saveCardSaga)
}